import type { CSSProperties, ReactElement } from 'react';

import { whiteAlpha } from '@/config/appColors';
import type { ContextChunkModel } from '@/domain/models/contextChunkModel';
import { useL10n } from '@/l10n/useL10n';
import { SvgAsset } from '@/presentation/widgets/SvgAsset';
import { lightenColor } from '@/utils/extensions/colorExtension';

import styles from './ChatMessageSourceTile.module.css';

/** Перенос `chat_page/chat_message_source_tile.dart`. */

/** `Colors.white.withValues(alpha: 0.1)` */
const BACKGROUND_COLOR = whiteAlpha(0.1);

/** `highlightColor: backgroundColor.lightenColor(0.9)` — формулой, как в Dart. */
const HIGHLIGHT_COLOR = lightenColor(BACKGROUND_COLOR, 0.9);

export interface ChatMessageSourceTileProps {
  readonly chunks: readonly ContextChunkModel[];
  readonly onPressed?: (() => void) | null;
}

export function ChatMessageSourceTile(
  props: ChatMessageSourceTileProps,
): ReactElement {
  const { chunks, onPressed } = props;
  const l10n = useL10n();
  const style = {
    '--source-background': BACKGROUND_COLOR,
    '--source-highlight': HIGHLIGHT_COLOR,
  } as CSSProperties;
  return (
    <button
      type="button"
      className={styles.tile}
      style={style}
      disabled={onPressed == null}
      onClick={() => onPressed?.()}
    >
      <div className={styles.header}>
        <span className={styles.title}>{l10n.source}</span>
        <SvgAsset icon="arrowRight" />
      </div>
      <span className={styles.answers}>
        {chunks.map((chunk) => chunk.answer).join(' ')}
      </span>
    </button>
  );
}
